import "./Info.modules.scss";

import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setActivePlanet } from "../../redux/actions";
import { convertToClass, isPortrait } from "../../assets/javascript/utils";

class InfoSlide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: true,
      hasLoaded: false,
      canActivateAR: false,
    };

    this.arButtonRef = React.createRef();
    this.modelViewerRef = React.createRef();
  }

  componentDidMount() {
    const _canActivateAR =
      this.modelViewerRef.current.getAttribute("canactivatear") === "true";

    if (_canActivateAR) {
      document.querySelectorAll("html")[0].classList.add("-ar-enabled");
    }

    this.setState({
      canActivateAR: _canActivateAR,
    });

    this.modelViewerRef.current.addEventListener("load", () => {
      this.setState({
        hasLoaded: true,
      });
    });
  }

  componentWillUnmount() {
    this.modelViewerRef.current.removeEventListener("load", () => {
      this.setState({
        hasLoaded: true,
      });
    });
  }

  onClickCloseButton() {
    this.props.actions.onSetPlanetActive(-1);
  }

  render() {
    const { hasLoaded, canActivateAR } = this.state;
    const {
      data,
      isArSupported,
      arButtonClicked,
      isArClicked,
      onClickViewSolarSystem,
      isPromiseDone,
      hasSolarSystemLoaded,
    } = this.props;

    return (
      <div className="info__slide">
        <h2>
          {data.name}
          <span>{data.nickname}</span>
        </h2>

        <div className="info__wrap">
          <button
            className="info__model"
            type="button"
            onClick={() => {
              if (isPromiseDone) {
                if (
                  isArSupported &&
                  hasLoaded &&
                  canActivateAR &&
                  isPortrait()
                ) {
                  if (data.name === "Sun") {
                    onClickViewSolarSystem();
                  } else {
                    this.arButtonRef.current.click();
                  }
                } else if (!isArSupported) {
                  window.location = "/telescope/";
                }
              }
            }}>
            <model-viewer
              ref={this.modelViewerRef}
              src={`/assets/models/${convertToClass(data.name)}.glb`}
              alt={`A 3D model of ${data.name}`}
              ar
              ar-scale="auto"
              autoplay
              auto-rotate-delay="0"
              ar-modes="scene-viewer quick-look" // * Values: webxr scene-viewer quick-look
              seamless-poster
              auto-rotate
              bounds="tight"
              shadow-intensity="0"
              loading="lazy"
              canActivateAR>
              <div
                slot="ar-button"
                ref={this.arButtonRef}
                style={{ display: "none" }}>
                View in 3D
              </div>
            </model-viewer>
          </button>

          <ul className="info__bytes">
            <li>
              Planet Type <span>{data.type}</span>
            </li>
            <li>
              Length of Year <span>{data.lengthOfYear}</span>
            </li>
            <li>
              Distance from Sun <span>{data.distanceFromSun}</span>
            </li>
            <li>
              Moons <span>{data.moons}</span>
            </li>
          </ul>

          <p>{data.description}</p>
        </div>

        <button
          type="button"
          className="info__btn -close"
          onClick={() => {
            this.onClickCloseButton();
          }}>
          <span className="sr-only">Close info window</span>
          <svg viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            />
          </svg>
        </button>

        {hasLoaded && canActivateAR && (
          <button
            type="button"
            className={`info__btn -ar ${isArClicked && "-active"}`}
            onClick={() => {
              arButtonClicked();

              if (data.name === "Sun") {
                onClickViewSolarSystem();
              } else {
                this.arButtonRef.current.click();
              }
            }}>
            <svg style={{ width: 24, height: 24 }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M17,22V20H20V17H22V20.5C22,20.89 21.84,21.24 21.54,21.54C21.24,21.84 20.89,22 20.5,22H17M7,22H3.5C3.11,22 2.76,21.84 2.46,21.54C2.16,21.24 2,20.89 2,20.5V17H4V20H7V22M17,2H20.5C20.89,2 21.24,2.16 21.54,2.46C21.84,2.76 22,3.11 22,3.5V7H20V4H17V2M7,2V4H4V7H2V3.5C2,3.11 2.16,2.76 2.46,2.46C2.76,2.16 3.11,2 3.5,2H7M13,17.25L17,14.95V10.36L13,12.66V17.25M12,10.92L16,8.63L12,6.28L8,8.63L12,10.92M7,14.95L11,17.25V12.66L7,10.36V14.95M18.23,7.59C18.73,7.91 19,8.34 19,8.91V15.23C19,15.8 18.73,16.23 18.23,16.55L12.75,19.73C12.25,20.05 11.75,20.05 11.25,19.73L5.77,16.55C5.27,16.23 5,15.8 5,15.23V8.91C5,8.34 5.27,7.91 5.77,7.59L11.25,4.41C11.5,4.28 11.75,4.22 12,4.22C12.25,4.22 12.5,4.28 12.75,4.41L18.23,7.59Z"
              />
            </svg>
            <span>View in 3D</span>
          </button>
        )}

        {isPromiseDone && isArSupported && hasSolarSystemLoaded && (
          <button
            type="button"
            className="info__btn -orrery"
            onClick={() => {
              onClickViewSolarSystem();
            }}>
            <svg viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M18.36,2.64C20,2.64 21.36,4 21.36,5.64C21.36,7.29 20,8.64 18.36,8.64C16.71,8.64 15.36,7.29 15.36,5.64C15.36,5.34 15.41,5.06 15.5,4.8C14.43,4.29 13.25,4 12,4A8,8 0 0,0 4,12L4.04,12.84L2.05,13.05L2,12A10,10 0 0,1 12,2C13.69,2 15.28,2.42 16.67,3.16C17.16,2.83 17.74,2.64 18.36,2.64M18.36,4.64A1,1 0 0,0 17.36,5.64A1,1 0 0,0 18.36,6.64C18.92,6.64 19.36,6.19 19.36,5.64C19.36,5.08 18.92,4.64 18.36,4.64M5.64,15.36C7.29,15.36 8.64,16.71 8.64,18.36C8.64,18.66 8.59,18.94 8.5,19.2C9.57,19.71 10.75,20 12,20A8,8 0 0,0 20,12L19.96,11.16L21.95,10.95L22,12A10,10 0 0,1 12,22C10.31,22 8.72,21.58 7.33,20.84C6.84,21.17 6.26,21.36 5.64,21.36C4,21.36 2.64,20 2.64,18.36C2.64,16.71 4,15.36 5.64,15.36M5.64,17.36C5.08,17.36 4.64,17.81 4.64,18.36C4.64,18.92 5.08,19.36 5.64,19.36A1,1 0 0,0 6.64,18.36A1,1 0 0,0 5.64,17.36M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8Z"
              />
            </svg>

            <span className="sr-only">View solar system</span>
          </button>
        )}
      </div>
    );
  }
}

const mapStateToProps = null;

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      onSetPlanetActive: bindActionCreators(setActivePlanet, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoSlide);
